






































import { defineComponent } from "@vue/composition-api";
import LandingButton from "../LandingButton";
import LandingContainer from "../LandingContainer";

export default defineComponent({
  name: "HeroBlock",
  components: { LandingButton, LandingContainer },
});
